module.exports = __webpack_public_path__ + "rachel-adfacf4359cdb58627e31e44def48eb6.png";